import { post } from './require'

const cmsApi = {
  AddMediaShareWatchLog: (params) => post('/Open/AddMediaShareWatchLog', params, 'media')
}

export default cmsApi
